import type { ExamSection, QuestionType } from '@examflow/core';
import { createSectionConstraint } from '@examflow/core';
import {
  toeflListeningDefinition,
  toeflReadingDefinition,
  toeflSpeakingDefinition,
  toeflWritingDefinition,
} from './questionTypes';

/**
 * TOEFL 阅读部分配置
 */
export const TOEFL_READING_SECTION: ExamSection = {
  id: 'reading',
  name: '阅读 (Reading)',
  duration: 54, // 54-72分钟（根据题目数量）
  /**
   * Platform mock reference for classic iBT-scale reading (≈3 passages).
   * Live Adaptive/Enhanced forms differ — adjust when product locks a form.
   */
  questionCount: 30,
  questionTypes: ['single_choice' as QuestionType],
  questionTypeConstraints: [createSectionConstraint(toeflReadingDefinition.id)],
};

/**
 * TOEFL 听力部分配置
 */
export const TOEFL_LISTENING_SECTION: ExamSection = {
  id: 'listening',
  name: '听力 (Listening)',
  duration: 41, // 41-57分钟
  /** Classic iBT-scale listening item count for platform full mock. */
  questionCount: 28,
  questionTypes: ['single_choice' as QuestionType],
  questionTypeConstraints: [createSectionConstraint(toeflListeningDefinition.id)],
};

/**
 * TOEFL 口语部分配置
 */
export const TOEFL_SPEAKING_SECTION: ExamSection = {
  id: 'speaking',
  name: '口语 (Speaking)',
  duration: 17, // 17分钟
  /** Four speaking tasks. */
  questionCount: 4,
  questionTypes: ['fill_blank' as QuestionType],
  questionTypeConstraints: [createSectionConstraint(toeflSpeakingDefinition.id)],
};

/**
 * TOEFL 写作部分配置
 */
export const TOEFL_WRITING_SECTION: ExamSection = {
  id: 'writing',
  name: '写作 (Writing)',
  duration: 50, // 50分钟
  /** Two writing tasks. */
  questionCount: 2,
  questionTypes: ['fill_blank' as QuestionType],
  questionTypeConstraints: [createSectionConstraint(toeflWritingDefinition.id)],
};

/**
 * TOEFL 考试部分
 */
export const TOEFL_SECTIONS: ExamSection[] = [
  TOEFL_READING_SECTION,
  TOEFL_LISTENING_SECTION,
  TOEFL_SPEAKING_SECTION,
  TOEFL_WRITING_SECTION,
];

/**
 * 获取总考试时长（分钟）
 */
export function getTotalDuration(): number {
  return TOEFL_SECTIONS.reduce((sum, section) => sum + section.duration, 0);
}
